import React, {useState, useRef} from "react";
import {Button, Col, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap/Table";
import Pagination from "../../components/common/Pagination";
import TableTopBar from "../../components/tables/top/TableTopBar";
import Swal from "sweetalert2";
import '@sweetalert2/theme-dark/dark.scss';
import {delTopic, getTopicsList, getUserTOPListAll} from "../../api/apiClient";
// import {DownloadTableExcel} from "react-export-table-to-excel";
import usePdf from "../../hook/usePdf";
import {exportExcel} from "../../common/exportExcel";

const TableTopicSetting = ({
                             propMqttId,
                             currentPage,
                             setCurrentPage,
                             listPageSize,
                             setListPageSize,
                             total,
                             tableList,
                             updateList,
                             propSetTopicInfo,
                             propSetType,
                             setTableList,
                             setTotal
                           }) => {

  const onClickTopic = (e) => {
    propSetTopicInfo({
      mqttId: propMqttId,
      topic: e.target.dataset.topic,
      readPermission: parseInt(e.target.dataset.read),
      writePermission: parseInt(e.target.dataset.write),
      rm: e.target.dataset.rm
    });
    propSetType('put');
  };

  // select ////////////////////////////////////
  const updatePageSize = (aSize) => {
    setCurrentPage(1);
    setListPageSize(parseInt(aSize));
  };

  // 체크박스
  // 체크된 아이템을 담을 배열
  const [checkItems, setCheckItems] = useState([]);

  // 체크박스 단일 선택
  const handleSingleCheck = (checked, id) => {
    if (checked) {
      // 단일 선택 시 체크된 아이템을 배열에 추가
      setCheckItems(prev => [...prev, id]);
    } else {
      // 단일 선택 해제 시 체크된 아이템을 제외한 배열 (필터)
      setCheckItems(checkItems.filter((el) => el !== id));
    }
  };

  // 체크박스 전체 선택
  const handleAllCheck = (checked) => {
    if (checked) {
      // 전체 선택 클릭 시 데이터의 모든 아이템(id)를 담은 배열로 checkItems 상태 업데이트
      const idArray = [];
      tableList.forEach((el) => {
        idArray.push(el.topic);
      });
      setCheckItems(idArray);
    } else {
      // 전체 선택 해제 시 checkItems 를 빈 배열로 상태 업데이트
      setCheckItems([]);
    }
  };

  const delItem = () => {
    if (checkItems.length < 1) {
      alert("항목을 선택하세요.");
      return;
    }
    Swal.fire({
      title: `삭제하시겠습니까?`,
      text: `선택한 항목을 삭제합니다.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        // console.log(checkItems)
        delTopic(propMqttId, checkItems).then(res => {
          Swal.fire(
              '삭제되었습니다!',
              '',
              'success'
          );
          setCheckItems([]);
          updateList();
        }).catch(err => {
          // 에러 처리
          //console.log(err.response.data.message);
          Swal.fire(
              err.response.data.message,
              '',
              'error'
          );
        });
      }
    })
  };

  const tableRef = useRef(null);
  const [isExport, setIsExport] = useState(false);

  const onDownload = () => {
    exportExcel(tableRef, "토픽_상세.xls")
  }
  const getAllList = () => {
    setIsExport(true);

    getTopicsList(currentPage, 1000,
        propMqttId)
        .then((res) => {
              // console.log(res);
              if (res.data.data !== undefined) {
                setTableList(res.data.data.list);
                setTotal(res.data.data.total);
              }
            }
        );
  };

  const downloadExcelToTable = () => {
    getAllList();

    Swal.fire({
      title: `EXCEL 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
      }
      setIsExport(false);

      updateList();
    })
  };

  return (
      <>
        <Row>
          <Col md={8} className={""}>
            <TableTopBar
                propSelectOption={{
                  isEnable: true,
                  selItems: [15, 30, 50], //미구현
                  setFunc: updatePageSize,
                }}
                propExcelExport={{
                  isEnable: true,
                  exportFilename: 'doc.xlsx',
                  getFunc: null,
                }}
                propExcelDownload={{
                  isEnable: true,
                  getFunc: downloadExcelToTable,
                }}
                /*propPdfExport={{
                  isEnable: true,
                  exportFilename: 'doc.pdf',
                  getFunc: null,
                }}*/
                propPdf={{
                  isEnable: true,
                  getFunc: usePdf({
                    tableRef: tableRef,
                    setIsExport: setIsExport,
                    getAllList: getAllList,
                    updateList: updateList,
                    filename: '토픽_상세',
                  }),
                }}
                propDelete={{
                  isEnable: true,
                  delFunc: delItem,
                }}
                propReg={{
                  isEnable: false,
                  regFunc: null,
                }}
                // propControl = {{
                //     isEnable: true,
                //     ctlFunc: null,
                // }}
            />
          </Col>

          <Col md={12}>
            <div className={"table-responsive text-nowrap"}>
              <BootstrapTable hover className={"table text-center"} ref={tableRef}>
                <thead className={"table-head text-secondary"}>
                <tr className={"text-start"}>
                  {!isExport ?
                      <th className={"table-checkbox"}>
                        <input
                            type="checkbox"
                            name='check-all'
                            className={"checkbox check-all"}
                            onChange={(e) => handleAllCheck(e.target.checked)}
                            checked={checkItems.length === tableList.length}
                        />
                      </th> : ''}
                  <th className={"col-md-6"}>Topic</th>
                  <th className={"col"}>Read</th>
                  <th className={"col"}>Write</th>
                  <th className={"col-md-3"}>비고</th>
                </tr>
                </thead>
                <tbody className={`table-body text-start ${isExport ? "" : "text-white"}`}>
                {
                  Array.isArray(tableList) ?
                      (tableList.map((elem, idx) => {
                        return (<tr key={idx}>
                          {!isExport ?
                              <td className={"table-checkbox"}>
                                <input
                                    type="checkbox"
                                    className={"checkbox check"}
                                    onChange={(e) => handleSingleCheck(e.target.checked, elem.topic)}
                                    checked={checkItems.includes(elem.topic)}
                                />
                              </td> : ''}
                          <td data-topic={elem.topic}
                              data-read={elem.r_flag}
                              data-write={elem.w_flag}
                              data-rm={elem.rm}
                              onClick={onClickTopic}
                              className={"column-title"}
                          >{elem.topic}</td>
                          <td>{elem.r_flag === '0' ? '' : 'O'}</td>
                          <td>{elem.w_flag === '0' ? '' : 'O'}</td>
                          <td>{elem.rm}</td>
                        </tr>);
                      })) :
                      ('')
                }
                </tbody>
              </BootstrapTable>
            </div>
          </Col>
          <Col className={""}>
            <Pagination
                propCurPage={currentPage}
                propTotal={total}
                propPageSize={listPageSize}
                propSetNewPage={setCurrentPage}
            />
          </Col>
        </Row>
      </>
  );
};


export default TableTopicSetting;